<script>
export default {
  beforeCreate () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    concatPathImage (file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/dados/user/UserBase.vue